// extracted by mini-css-extract-plugin
export default {"alert":"sNkJuvx4LQgMXDTmumAx"};